// extracted by mini-css-extract-plugin
module.exports = {"container":"partners_container__XRUNc","description":"partners_description__ROsSD","partners":"partners_partners__5KX_D"};